import { render } from "./file-earmark-richtext.vue?vue&type=template&id=6d30cfaa"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/file-earmark-richtext.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d30cfaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d30cfaa', __exports__)) {
    api.reload('6d30cfaa', __exports__)
  }
  
  module.hot.accept("./file-earmark-richtext.vue?vue&type=template&id=6d30cfaa", () => {
    api.rerender('6d30cfaa', render)
  })

}


export default __exports__